import { Children, Fragment, ReactNode } from 'react';

interface BreadcrumbsContainerProps {
  children: ReactNode;
  separator?: ReactNode;
}

const BreadcrumbsContainer = ({
  children,
  separator = '/',
}: BreadcrumbsContainerProps) => {
  return (
    <nav>
      <ul className="text-grey-60 flex items-center gap-1">
        {Children.map(children, (child, index) => (
          <Fragment key={index}>
            {child}
            {index < Children.count(children) - 1 && <span>{separator}</span>}
          </Fragment>
        ))}
      </ul>
    </nav>
  );
};

export default BreadcrumbsContainer;
